import { writable } from 'svelte/store';
export function defineStudioUrlStore(client) {
    return writable(typeof client === 'object' ? client?.config().stega.studioUrl : undefined);
}
